import { Grid } from '@material-ui/core';
import React from 'react';


export default class InterpretareLabelComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    interpretare = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 < cF1) {
                return `${val1}% - ${this.props.slab}`
            } else if (val1 > cF1 && val1 < cF2) {
                return `${val1}% - ${this.props.mediu} `
            } else {
                return `${val1}% - ${this.props.foarteBine} `
            }
        }
    }

    interpretare2 = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 > cF1) {
                return `${val1}% - ${this.props.slab}`
            } else if (val1 < cF1 && val1 > cF2) {
                return `${val1}% - ${this.props.mediu} `
            } else {
                return `${val1}% - ${this.props.foarteBine} `
            }
        }
    }

    interpretareColor = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 < cF1) {
                return `rgb(211 58	64)`
            } else if (val1 > cF1 && val1 < cF2) {
                return `rgb(229	178	59)`
            } else {
                return `rgb(24 165 58)`
            }
        }
    }

    interpretareColor2 = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 > cF1) {
                return `rgb(211 58	64)`
            } else if (val1 < cF1 && val1 > cF2) {
                return `rgb(229	178	59)`
            } else {
                return `rgb(24 165 58)`
            }
        }
    }
    render() {
        return (
            <Grid container>
                <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    {!this.props.interpretare2 &&

                        <span> {this.props.subtitle ? this.props.subtitle : this.props.dictionary.financiar.diagnostic}  <span style={{ color: this.interpretareColor(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2) }}>{this.interpretare(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2)} </span></span>
                    }

                    {this.props.interpretare2 &&

                        <span> {this.props.subtitle ? this.props.subtitle : this.props.dictionary.financiar.diagnostic}  <span style={{ color: this.interpretareColor2(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2) }}>{this.interpretare2(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2)} </span></span>
                    }

                </Grid>
            </Grid >
        );
    }
}